import { args } from "../../lib/args/args";
import { config } from "../../lib/shared/config";
import { out } from "../../lib/output/out";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/** Forgets the local session only; issued API keys keep working. */
export function logoutCommand(parsed: ParsedArgs): void {
  args.expect(parsed, {});

  config.clear();

  if (parsed.booleans.has("json")) {
    out.json({ signedOut: true });
    return;
  }

  out.line("Signed out.");
}
